// extracted by mini-css-extract-plugin
module.exports = {"section":"page_section__vZQfy","coverImage":"page_coverImage__vNuks","footerImage":"page_footerImage__B70G5"};